import React, { useState, useEffect } from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import RequestHandler from "util/RequestHandler";

const PosReportTransactionCountYesterday = () => {
  const [widgetData, setWidgetData] = useState({
    loading: true,
  });

  useEffect(() => getData(), []);

  const getData = () => {
    RequestHandler.get("/PosDashboard/TransactionCountYesterday").then((response) => {
      setWidgetData({
        data: response.data,
        loading: false,
      });
    });
  };

  return (
    <Widgets
      icon="stats"
      currency={"Bugün"}
      title="İşlem Adedi"
      totalBalance={
        <CurrencyFormat
          value={widgetData.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={""}
        />
      }
    />
  );
};

export default PosReportTransactionCountYesterday;
